
import { EventFiltersActions, EventFiltersActionTypes } from '../actions/event-filters.actions';

export interface State {
  device_status: number;
}

export const initialState: State = {
  device_status: 2
};

export function reducer(state = initialState, action: EventFiltersActions): State {
  switch (action.type) {

    case EventFiltersActionTypes.LoadEventFilterss:
      return {...state, device_status: action.payload.device_status};

    default:
      return state;
  }
}
